<div
  panDragDropFiles
  [applyDefaultDragStyle]="false"
  (files)="onDrop($event)"
  (dragActive)="dragActive.set($event)"
  panPasteFiles
  (pasted)="onPaste($event)"
  tabindex="0"
  role="button"
  [attr.aria-label]="dropzoneAriaLabel()"
  [attr.aria-describedby]="dropzoneAriaDescribedBy()"
  (keydown)="onDropzoneKeydown($event)"
  [ngClass]="dropzoneClasses()"
  data-testid="filepicker-dropzone"
>
  <input
    #fileInput
    (change)="onPick($event)"
    class="sr-only"
    [multiple]="multiple()"
    [accept]="acceptAttr()"
    type="file"
    data-testid="filepicker-file-input"
  />

  <p id="filepicker-instructions">
    Drop files or paste, or
    <button type="button" class="underline" (click)="openPicker()" data-testid="filepicker-click-here">click here</button>
    ({{ acceptLabel() }})
  </p>

  <section class="gap-2 flex flex-row flex-wrap mt-3" data-testid="filepicker-previews">
    @for (url of previewUrls(); track $index) {
      @if (previewTemplate(); as preview) {
        <ng-container *ngTemplateOutlet="preview; context: previewContext(url)"></ng-container>
      } @else {
        <img class="w-12 h-12 rounded-md object-cover" [src]="url" [alt]="''" data-testid="filepicker-default-preview" />
      }
    }
  </section>

  @if (validationError()) {
    <div
      id="filepicker-validation-error"
      class="text-danger mt-2"
      data-testid="filepicker-validation-error"
      role="status"
      aria-live="polite"
    >
      {{ validationError() }}
    </div>
  }
</div>
